import { Inject, Injectable } from '@angular/core';

import { GameType } from '@bpos/v1/sports-promo';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipError } from '../../../errors/betslip-error';
import { RewardTokensGameTypeError } from '../../../errors/general/reward-tokens-game-type-error';
import { IExtendedMessage, MessageFormatter } from './message-formatter';

@Injectable()
export class RewardTokensGameTypeMessageFormatter extends MessageFormatter<RewardTokensGameTypeError> {
    private messages: IBetslipMessages;
    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private stringInterpolationPipe: StringInterpolationPipe,
    ) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: RewardTokensGameTypeError): Observable<string | IExtendedMessage> {
        let typeText = '';

        switch (error.gameType) {
            case GameType.InPlay:
                typeText = this.messages.crmTokens.errors.GameTypeInPlay;
                break;
            case GameType.PreMatch:
                typeText = this.messages.crmTokens.errors.GameTypePreMatch;
                break;
        }

        const template = this.messages.crmTokens.errors.CriteriaNotMet;

        return of(this.stringInterpolationPipe.transform(template, { criteria: typeText }));
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof RewardTokensGameTypeError;
    }
}
